'use client';

import { getOptionSelectionKey } from '@/utilities/attributeFilters';
import { BRAND_FILTER_SLUG } from '@/utilities/attributeFilters/constants';
import { AttributeFiltersSelection, AttributeValueSelection } from '@/utilities/attributeFilters/models';

import { AttributeCheckboxFilter } from '../AttributeCheckboxFilter';
import { AttributeOptionItem } from '../AttributeCheckboxFilter/models';
import { AttributeBrandFilterProps } from './models';

import { CategoryBrandType } from '@/server/services/core/brand/models';
import { CategoryFilterAttribute } from '@/server/services/core/category/models';

const brandAttribute: CategoryFilterAttribute = {
    attributeId: 0,
    name: '',
    slug: BRAND_FILTER_SLUG,
    type: 'TEXT',
    dimension: 'OTHER',
    displayOrder: 0,
    filterMode: 'VALUES',
    options: []
};

export const AttributeBrandFilter = ({ config, draft }: AttributeBrandFilterProps) => {
    const { brands, selectedBrands, search, isLoading, onSearchChange, onChange } = config;
    const selectedIds = draft ? config.draftSelectedIds : config.selectedIds;

    const toOptionItem = (brand: CategoryBrandType): AttributeOptionItem => ({
        id: getOptionSelectionKey(String(brand.id)),
        label: brand.name,
        value: String(brand.id),
        unitCode: null
    });

    const selection: AttributeFiltersSelection = {
        values: { [BRAND_FILTER_SLUG]: selectedIds.map((id) => ({ value: String(id) })) },
        ranges: {}
    };

    const handleSetValues = (_slug: string, values: AttributeValueSelection[]) => {
        onChange(
            values.map((item) => Number(item.value)),
            draft ? { draft: true } : undefined
        );
    };

    return (
        <AttributeCheckboxFilter
            attribute={brandAttribute}
            selection={selection}
            draft={draft}
            optionItems={brands.map(toOptionItem)}
            selectedOptionItems={selectedBrands.map(toOptionItem)}
            remoteSearch={{ value: search, onChange: onSearchChange, isLoading }}
            onSetValues={handleSetValues}
        />
    );
};
